import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
    setIsServicesOpen(false);
  };

  return (
    <header className="header">
      {/* Top info bar */}
      <div className="header-top">
        <div className="container">
          <div className="header-contact">
            <span><span className="icon">✉</span> [email]</span>
            <span><span className="icon">📞</span> (657) 000-000</span>
            <span><span className="icon">📍</span> Texas, Block B</span>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="mobile-menu-overlay active" onClick={closeMenu} />
      )}

      <nav className="navbar">
        <div className="container">
          <div className="nav-brand">
            <Link to="/" className="logo">
              <span className="logo-text">Nexus Prime Group</span>
            </Link>
          </div>

          <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <Link to="/" className="nav-link" onClick={closeMenu}>Home</Link>
            <Link to="/about" className="nav-link" onClick={closeMenu}>About Us</Link>

            <div
              className="dropdown"
              onMouseEnter={() => !isMenuOpen && setIsServicesOpen(true)}
              onMouseLeave={() => !isMenuOpen && setIsServicesOpen(false)}
            >
              <button
                className="nav-link dropdown-toggle"
                onClick={(e) => {
                  if (window.innerWidth <= 768) {
                    e.preventDefault();
                    setIsServicesOpen(!isServicesOpen);
                  }
                }}
                aria-expanded={isServicesOpen}
              >
                Services
              </button>
              <div className={`dropdown-menu ${isServicesOpen ? 'show' : ''}`}>
                <Link to="/services#credentialing" className="dropdown-item" onClick={closeMenu}>Credentialing & Contracting</Link>
                <Link to="/services#intake" className="dropdown-item" onClick={closeMenu}>Patient Intake & Scheduling</Link>
                <Link to="/services#authorization" className="dropdown-item" onClick={closeMenu}>Prior Authorization</Link>
                <Link to="/services#virtual" className="dropdown-item" onClick={closeMenu}>Medical Virtual Assistance</Link>
                <Link to="/services#billing" className="dropdown-item" onClick={closeMenu}>Medical Billing</Link>
                <Link to="/services#denials" className="dropdown-item" onClick={closeMenu}>Claim Denial Management</Link>
                <Link to="/services#rcm" className="dropdown-item" onClick={closeMenu}>Full RCM Services</Link>
                <Link to="/services#qa" className="dropdown-item" onClick={closeMenu}>Quality Assurance Services</Link>
              </div>
            </div>

            <Link to="/team" className="nav-link" onClick={closeMenu}>Our Team</Link>
            <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact</Link>
          </div>

          <div className="nav-actions">
            <a href="tel:6570000000" className="btn btn-primary">Get In Touch</a>
          </div>

          <button
            className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={() => { setIsMenuOpen(!isMenuOpen); if (!isMenuOpen) setIsServicesOpen(false); }}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
